module.exports = __webpack_public_path__ + "static/img/shannon-family-home.ac8ce21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shannon-family-home.jpg
// module id = 347
// module chunks = 0